import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

const QRCode = ({
  link,
  title,
  imageSettings,
  size,
  bgColor,
  fgColor,
  level,
}) => (
  <QRCodeSVG
    value={link}
    title={title}
    size={size}
    bgColor={bgColor}
    fgColor={fgColor}
    level={level}
    imageSettings={imageSettings}
  />
);

QRCode.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string,
  imageSettings: PropTypes.shape({
    src: PropTypes.string.isRequired,
    x: PropTypes.number,
    y: PropTypes.number,
    height: PropTypes.number,
    width: PropTypes.number,
    excavate: PropTypes.bool,
  }),
  size: PropTypes.number,
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
};

QRCode.defaultProps = {
  title: '',
  imageSettings: null,
  size: 128,
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  level: 'L',
};

export default QRCode;
